import React, { useEffect } from 'react';
import RoutesList from "./routes";
import InstallPrompt from "./InstallPrompt";
import ErrorBoundary from "./components/error-boundary/ErrorBoundary";
import { BrowserRouter as Router } from "react-router-dom";
import { Provider } from "react-redux";
import { StyledEngineProvider } from "@mui/material/styles";
import { store } from "./store";
import "./index.scss";
import Pusher from "pusher-js";
import { Toaster } from "react-hot-toast";
import Theme from "./theme/theme";
import { pruneInvalidStoredClinic } from "./services/selectedClinic";

// Earlier builds could persist the literal strings "undefined"/"null" as the
// selected clinic, which made the location gate think a clinic was chosen.
// Drop those once on boot so those visitors get prompted properly.
pruneInvalidStoredClinic();
// Brand-themed scrollbar — matches the CRM sidebar (pink thumb on soft-pink track).
export const scrollCSS = {
    "&::-webkit-scrollbar": {
      width: "8px",
      height: "8px"
    },
    "&::-webkit-scrollbar-track": {
      background: "#FAEFF5",
      borderRadius: "8px"
    },
    "&::-webkit-scrollbar-thumb": {
      borderRadius: "8px",
      background: "#A72C68",
      border: "2px solid #FAEFF5"
    },
    "&::-webkit-scrollbar-thumb:hover": {
      background: "#9CA3AF"
    },
    scrollbarColor: "#A72C68 #FAEFF5",
    scrollbarWidth: "thin"
  };
  
  


const App = () => {
    useEffect(() => {
        // Initialize Pusher
        const pusher = new Pusher('5e9dcc6e9cd79dc83685', { cluster: 'mt1' });

        // Subscribe to the specified channel
        const deploymentChannel  = pusher.subscribe('new.deployment');

        // Bind to the 'subscription succeeded' event
        deploymentChannel.bind('pusher:subscription_succeeded', () => {
            //console.log('Successfully subscribed to the new.deployment channel.');
        });

        // Bind to the custom event
        deploymentChannel.bind("App\\Events\\NewDeploymentEvent", (data) => {
            //console.log('NewDeploymentEvent received:', data);
            window.location.reload(); // Reload the browser upon receiving the event
        });
        // Subscribe to the 'remove.session' channel
        const sessionChannel = pusher.subscribe('remove.session');

        // Bind to the custom event on 'remove.session' channel
        sessionChannel.bind("App\\Events\\RemoveSessionEvent", (data) => {
            //console.log('RemoveSessionEvent received:', data);

            // Perform logout or session removal logic here
            // For example, clearing local storage and redirecting to login
            localStorage.clear();
            window.location.href = '/login'; // Adjust as needed
        });

        // Cleanup function to unbind all events and unsubscribe from the channel when the component unmounts
        return () => {
            deploymentChannel.unbind_all();
            deploymentChannel.unsubscribe();
            sessionChannel.unbind_all();
            sessionChannel.unsubscribe();
        };
    }, []);
    return (
      <React.StrictMode>
        <Router>
            <Provider store={store}>
                <StyledEngineProvider injectFirst>
                    <Toaster
                        position={"top-right"}
                        gutter={10}
                        toastOptions={{
                            className: "react-hot-toast",
                            duration: 3500,
                            style: {
                                background: '#fff',
                                color: '#1a1a2e',
                                border: '1px solid #F0CDDB',
                                borderRadius: '12px',
                                boxShadow: '0 10px 30px rgba(167,44,104,0.15), 0 1px 3px rgba(0,0,0,0.06)',
                                padding: '12px 16px',
                                fontSize: '13.5px',
                                fontWeight: 500,
                                fontFamily: 'helvetica-lt-std-bold, sans-serif',
                                maxWidth: '420px',
                                borderLeft: '4px solid #A72C68',
                            },
                            success: {
                                duration: 3500,
                                iconTheme: { primary: '#16A34A', secondary: '#fff' },
                                style: { borderLeft: '4px solid #16A34A' },
                            },
                            error: {
                                duration: 5000,
                                iconTheme: { primary: '#DC2626', secondary: '#fff' },
                                style: { borderLeft: '4px solid #DC2626' },
                            },
                            loading: {
                                iconTheme: { primary: '#A72C68', secondary: '#FAEFF5' },
                                style: { borderLeft: '4px solid #A72C68' },
                            },
                        }}
                    />
                    <Theme>
                        <ErrorBoundary>
                            <RoutesList/>
                        </ErrorBoundary>
                    </Theme>
                </StyledEngineProvider>
            </Provider>
        </Router>
        <InstallPrompt />
        </React.StrictMode>
    );
};

export default App;
